<template>
  <div class="footer" style="border-top:4px solid #2E8EEB">
    <div class="info">
      <div class="phone">{{ phone || "000-0000-0000" }}</div>
      <div class="records">
        <!-- <p>内容纠错 | 使用帮助| 关于我们| 隐私声明| 网站地图| 网站建议</p> -->
        <p>www.zhcp.org.cn 版权所有 主办单位：中国智慧工程研究会 联系我们: {{ phone }}</p>
        <p><a href="https://beian.miit.gov.cn/" target="_blank" style="color:#000">ICP备案号: {{ recodenum }}</a>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/img/police.png"
                            width="73" height="78" style="width: 29px; height: 31px;">京公网安备11010602201231 </span></p>
        <!-- <p>技术支持：<a href="http://www.beijsci.com" target="_blank" style="color:#fff">北捷科技</a></p>
          <p>{{ copyright }}  &nbsp;|&nbsp; {{ recodenum }}</p>
          <p>电话：{{ mobile }}  &nbsp;|&nbsp; E-mail：{{ email }}</p>  -->
        <!-- <p>QQ：739436060 | 法律顾问：王蔚律师</p> -->
      </div>
      <div class="qrcode right">
        <img width="127" height="127"
          :src="rightcodepic ? `${IP_TEST}/uploads/${rightcodepic}` : '/static/img/gzhqr.jpg'">
      </div>
      <a class="right" href="javascript:;">{{ rightcodetext||'官方微信公众号' }}</a>
      <div class="qrcode">
        <img width="127" height="127" :src="leftcodepic ? `${IP_TEST}/uploads/${leftcodepic}` : '/static/img/gzh_qr.png'">
      </div>
      <a href="javascript:;">{{ leftcodetext||'扫码访问' }}</a>
    </div>
  </div>
</template>

<script>
import { IP_TEST } from '@/config';
export default {
  name: "Footer",
  computed: {
    copyright() {
      return this.$store.getters.copyright;
    },
    recodenum() {
      return this.$store.getters.recodenum;
    },
    address() {
      return this.$store.getters.address;
    },
    email() {
      return this.$store.getters.email;
    },
    name() {
      return this.$store.getters.name;
    },
    phone() {
      return this.$store.getters.phone;
    },
    mobile() {
      return this.$store.getters.mobile;
    },
    shortname() {
      return this.$store.getters.shortname;
    },
    leftcodepic() {
      return this.$store.getters.leftcodepic;
    },
    rightcodepic() {
      return this.$store.getters.rightcodepic;
    },
    leftcodetext() {
      return this.$store.getters.leftcodetext;
    },
    rightcodetext() {
      return this.$store.getters.rightcodetext;
    },
  },
  data() {
    return {
      links: [],
      members: [],
      separtments: [],
      relatives: [],
      IP_TEST,
      isSelect: 'members'
    }
  }
};
</script>
<style scoped>
.footer {
  position: relative;
  margin-top: 52px;
  height: 289px;
  background: #FFFFFF;
  background-image: url(/static/img/img/baidijianju.png);
  background-repeat: no-repeat;
  background-position: right bottom;
}

.footer>.info {
  position: relative;
  margin: 0 auto;
  height: 282px;
  width: 1300px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
}

.footer>.info>.phone {
  position: absolute;
  padding-left: 72px;
  top: 51px;
  left: 8px;
  font-size: 47px;
  font-family: DINMittelschrift;
  font-weight: 400;
  color: #2E8EEB;
  line-height: 47px;
  font-style: italic;
   background-image: url(/static/img/img/tonghua.png);
  background-repeat: no-repeat;
  background-position: left center;
}

.records {
  position: absolute;
  top: 141px;
  left: 0px;
  width: 984px;
  height: 120px;
  line-height: 42px;
  overflow: hidden;
}

.records>p {
  margin-bottom: 28px;
  height: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  line-height: 16px;
  opacity: 0.8;
}

.qrcode {
  position: absolute;
  top: 61px;
  right: 3px;
  width: 135px;
  height: 135px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer>.info>div.right {
  top: 61px;
  right: 180px;
}

.footer>.info>a.right {
  right: 180px;
}

.footer>.info>a {
  position: absolute;
  width: 135px;
  top: 200px;
  right: 4px;
  height: 18px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 18px;
  text-align: center;

}

.footer>.info>a::before,
.footer>.info>a::after {
  position: absolute;
  top: 8.5px;
  content: '';
  background: #FFFFFF;
  width: 4px;
  height: 4px;
  background: #FFFFFF;
  border-radius: 50%;
}

.footer>.info>a::before {
  left: 0;
}

.footer>.info>a::after {
  right: 0;
}</style>
